import { createContext } from 'react';
import { defaultState } from './reducer';

const Context = createContext({
  ...defaultState,
  dispatch: (action?: any) => {},
});

export default Context;
